var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, QueryList, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { AlertifyService } from '../../../../services/alertify.service';
import { PlaceService } from '../../../../services/place.service';
import { ToggleFeaturesModalData } from './toggle.features.modal.provider';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { EventSpiderModalComponent } from '../event.spider/event.spider.modal.component';
import { EventSpiderModalActions, EventSpiderModalData, } from '../event.spider/event.spider.modal.provider';
import { ModalService } from '../../../../common/services/modal.service';
var ToggleFeaturesModalComponent = /** @class */ (function (_super) {
    __extends(ToggleFeaturesModalComponent, _super);
    function ToggleFeaturesModalComponent(fb, accountApiService, alertify, modalService, dialogRef, data) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.accountApiService = accountApiService;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.dialogRef = dialogRef;
        _this.loading = false;
        _this.isDefaultPlaceCategory = false;
        _this.itineraryLimitation = {
            limited: false,
            limitation: 6,
        };
        _this.account = Object.assign({}, data);
        _this.features = _this.account.account.toggle;
        return _this;
    }
    ToggleFeaturesModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.accountApiService.getToggles(this.account.account._id).subscribe(function (toggle) {
            if (toggle && toggle.toggle) {
                _this.isDefaultPlaceCategory = toggle.isDefaultPlaceCategory;
                _this.features.tripPlanner = isNullOrUndefined(toggle.toggle.tripPlanner)
                    ? true
                    : toggle.toggle.tripPlanner;
                _this.features.itinerary = isNullOrUndefined(toggle.toggle.itinerary)
                    ? true
                    : toggle.toggle.itinerary;
                _this.features.placeCalendar = isNullOrUndefined(toggle.toggle.placeCalendar)
                    ? true
                    : toggle.toggle.placeCalendar;
                _this.features.manualEvents = isNullOrUndefined(toggle.toggle.manualEvents)
                    ? true
                    : toggle.toggle.manualEvents;
                _this.features.eventByGeolocation = isNullOrUndefined(toggle.toggle.eventByGeolocation)
                    ? true
                    : toggle.toggle.eventByGeolocation;
                _this.features.regionalAccountType = isNullOrUndefined(toggle.toggle.regionalAccountType)
                    ? false
                    : toggle.toggle.regionalAccountType;
                _this.features.googleReviews = isNullOrUndefined(toggle.toggle.googleReviews)
                    ? true
                    : toggle.toggle.googleReviews;
                _this.features.facebookPosts = isNullOrUndefined(toggle.toggle.facebookPosts)
                    ? true
                    : toggle.toggle.facebookPosts;
                _this.features.nearbyPlacesRight = isNullOrUndefined(toggle.toggle.nearbyPlacesRight)
                    ? false
                    : toggle.toggle.nearbyPlacesRight;
                _this.features.googlePlaceGeofence = isNullOrUndefined(toggle.toggle.googlePlaceGeofence)
                    ? true
                    : toggle.toggle.googlePlaceGeofence;
                _this.features.tour =
                    isNullOrUndefined(toggle.tour) || isNullOrUndefined(toggle.tour.limit.limited)
                        ? {
                            limit: {
                                limited: false,
                                limitation: 6,
                            },
                            audioTour: false,
                        }
                        : toggle.tour;
                _this.features.placeCategory = isNullOrUndefined(toggle.toggle.placeCategory.activity)
                    ? {
                        activity: true,
                        accommodation: true,
                        shopping: true,
                        dining: true,
                        outdoor: true,
                        wellness: true,
                        entertainment: true,
                        travel: true,
                        other: true,
                        art: true,
                    }
                    : toggle.toggle.placeCategory;
                _this.features.clientDashboard = {
                    placeByGeoLocationTab: isNullOrUndefined(toggle.toggle.clientDashboard.placeByGeoLocationTab)
                        ? true
                        : toggle.toggle.clientDashboard.placeByGeoLocationTab,
                };
                _this.features.nearbyEventsInPlace = isNullOrUndefined(toggle.toggle.nearbyEventsInPlace)
                    ? false
                    : toggle.toggle.nearbyEventsInPlace;
                _this.features.nearbyPlacesInEvent = isNullOrUndefined(toggle.toggle.nearbyPlacesInEvent)
                    ? false
                    : toggle.toggle.nearbyPlacesInEvent;
                _this.features.eventTicketUrl = isNullOrUndefined(toggle.toggle.eventTicketUrl)
                    ? true
                    : toggle.toggle.eventTicketUrl;
                _this.features.eventLocationFilter = toggle.toggle.eventLocationFilter;
                _this.features.placeLocationFilter = toggle.toggle.placeLocationFilter;
                _this.features.jobBoard = toggle.toggle.jobBoard;
            }
            _this.loading = false;
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleTripPlanner = function () {
        var _this = this;
        this.features.tripPlanner = !this.features.tripPlanner;
        this.accountApiService
            .toggleTripPlanner(this.account.account._id, this.features.tripPlanner)
            .subscribe(function (data) {
            _this.tripPlannerSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleItinerary = function () {
        var _this = this;
        this.features.itinerary = !this.features.itinerary;
        this.accountApiService
            .toggleItinerary(this.account.account._id, this.features.itinerary)
            .subscribe(function (data) {
            _this.itinerarySuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.togglePlaceCalendar = function () {
        var _this = this;
        this.features.placeCalendar = !this.features.placeCalendar;
        this.accountApiService
            .togglePlaceCalendar(this.account.account._id, this.features.placeCalendar)
            .subscribe(function (data) {
            _this.placeCalendarSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleManualEvents = function () {
        var _this = this;
        this.features.manualEvents = !this.features.manualEvents;
        this.accountApiService
            .toggleEventCalendar(this.account.account._id, this.features.manualEvents)
            .subscribe(function (data) {
            _this.manualEventsSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleGoogleReviews = function () {
        var _this = this;
        this.features.googleReviews = !this.features.googleReviews;
        this.accountApiService
            .toggleGoogleReviews(this.account.account._id, this.features.googleReviews)
            .subscribe(function (data) {
            _this.googleReviewsSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleFacebookPosts = function ($event) {
        var _this = this;
        if (!this.features.facebookPosts && this.features.nearbyPlacesRight) {
            alert("You need to turn off the set nearby place to the right of the screen first, otherwise there is no enough space for the Facebook posts!");
            setTimeout(function () {
                $event.source.checked = false;
            });
            return;
        }
        this.features.facebookPosts = !this.features.facebookPosts;
        this.accountApiService
            .toggleFacebookPosts(this.account.account._id, this.features.facebookPosts)
            .subscribe(function (data) {
            _this.facebookPostsSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleNearbyPlacesRight = function ($event) {
        var _this = this;
        if (this.features.facebookPosts && !this.features.nearbyPlacesRight) {
            alert("You need to turn off the Facebook posts first, otherwise there is no enough space for the nearby places!");
            setTimeout(function () {
                $event.source.checked = false;
            });
            return;
        }
        this.features.nearbyPlacesRight = !this.features.nearbyPlacesRight;
        this.accountApiService
            .toggleNearbyPlacesRight(this.account.account._id, this.features.nearbyPlacesRight)
            .subscribe(function (data) {
            _this.nearbyPlacesRightSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleEventByGeolocation = function () {
        var _this = this;
        this.features.eventByGeolocation = !this.features.eventByGeolocation;
        this.accountApiService
            .toggleEventByGeolocation(this.account.account._id, this.features.eventByGeolocation)
            .subscribe(function (data) {
            _this.eventByGeolocationSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleJobBoard = function () {
        var _this = this;
        this.features.jobBoard = !this.features.jobBoard;
        this.accountApiService
            .toggleJobBoard(this.account.account._id, this.features.jobBoard)
            .subscribe(function (data) {
            _this.jobBoardSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleRegionalAccountType = function () {
        var _this = this;
        this.features.regionalAccountType = !this.features.regionalAccountType;
        this.accountApiService
            .toggleRegionalAccountType(this.account.account._id, this.features.regionalAccountType)
            .subscribe(function (data) {
            _this.regionalAccountTypeSuccess.success();
        });
        if (this.features.regionalAccountType) {
            this.account.account.toggle.regionalAccountType = true;
            this.modalService.show({
                component: EventSpiderModalComponent,
                providers: [
                    { provide: EventSpiderModalActions, useValue: new EventSpiderModalActions() },
                    {
                        provide: EventSpiderModalData,
                        useValue: new EventSpiderModalData(this.account.account),
                    },
                ],
                panelClass: 'width-modal-70p',
            });
        }
        else {
            this.account.account.toggle.regionalAccountType = false;
        }
    };
    ToggleFeaturesModalComponent.prototype.togglePlaceCategory = function (category, index) {
        var _this = this;
        this.features.placeCategory[category] = !this.features.placeCategory[category];
        this.accountApiService
            .togglePlaceCategory(this.account.account._id, this.features.placeCategory)
            .subscribe(function (data) {
            _this.placeCategorySuccesses.toArray()[index].success();
            //this.turnOffPlaceIfAllCategoriesAreTurnedOff();
        });
    };
    ToggleFeaturesModalComponent.prototype.togglePlaceClientDashboardPlaceByGeolocationTab = function () {
        var _this = this;
        this.features.clientDashboard.placeByGeoLocationTab =
            !this.features.clientDashboard.placeByGeoLocationTab;
        this.accountApiService
            .togglePlaceByGeolocationTab(this.account.account._id, this.features.clientDashboard.placeByGeoLocationTab)
            .subscribe(function (data) {
            _this.placeByGeolocationTabSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleNearbyEventsInPlace = function () {
        var _this = this;
        this.features.nearbyEventsInPlace = !this.features.nearbyEventsInPlace;
        this.accountApiService
            .toggleNearbyEventsInPlace(this.account.account._id, this.features.nearbyEventsInPlace)
            .subscribe(function (data) {
            _this.nearbyEventsInPlaceSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.togglePlaceLocationFilter = function () {
        var _this = this;
        this.features.placeLocationFilter = !this.features.placeLocationFilter;
        this.accountApiService
            .togglePlaceLocationFilter(this.account.account._id, this.features.placeLocationFilter)
            .subscribe(function (data) {
            _this.placeLocationFilterSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleEventLocationFilter = function () {
        var _this = this;
        this.features.eventLocationFilter = !this.features.eventLocationFilter;
        this.accountApiService
            .toggleEventLocationFilter(this.account.account._id, this.features.eventLocationFilter)
            .subscribe(function (data) {
            _this.eventLocationFilterSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleNearbyPlacesInEvent = function () {
        var _this = this;
        this.features.nearbyPlacesInEvent = !this.features.nearbyPlacesInEvent;
        this.accountApiService
            .toggleNearbyPlacesInEvent(this.account.account._id, this.features.nearbyPlacesInEvent)
            .subscribe(function (data) {
            _this.nearbyPlacesInEventeSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.toggleEventTicketUrl = function () {
        var _this = this;
        this.features.eventTicketUrl = !this.features.eventTicketUrl;
        this.accountApiService
            .toggleEventTicketUrl(this.account.account._id, this.features.eventTicketUrl)
            .subscribe(function (data) {
            _this.eventTicketUrlSuccess.success();
        });
    };
    ToggleFeaturesModalComponent.prototype.saveTourLimitation = function (event) {
        var _this = this;
        this.accountApiService
            .setTourLimitation(this.account.account._id, {
            limit: this.features.tour.limit,
            googlePlaceGeofence: this.features.googlePlaceGeofence,
            audioTour: this.features.tour.audioTour,
        })
            .finally(event.complete)
            .subscribe(function (data) {
            _this.alertify.success('Set itinerary limitation and Google place geofence');
        });
    };
    ToggleFeaturesModalComponent.prototype.turnOffPlaceIfAllCategoriesAreTurnedOff = function () {
        var isAllTurnedOff = PlaceService.isAllCategoriesTurnedOff(this.features.placeCategory);
        if (isAllTurnedOff) {
            this.togglePlaceCalendar();
        }
    };
    ToggleFeaturesModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return ToggleFeaturesModalComponent;
}(BaseComponent));
export { ToggleFeaturesModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/toggle.features/toggle.features.modal.component.ts.pre-build-optimizer.js